<template>
  <div class="py-1">
    <MenuOption
      id="send-now"
      :title="$t('W: Send nu')"
      @select="onSendNowClick">
      <template #icon>
        <IconLucideSend class="h-4 w-4" />
      </template>
    </MenuOption>
    <MenuOption
      id="mark-sent-manually"
      :title="$t('W: Generer og marker som manuelt sendt')"
      @select="onMarkSentManuallyClick">
      <template #icon>
        <IconLucideCheckCheck class="h-4 w-4" />
      </template>
    </MenuOption>
    <MenuOption
      id="cancel-schedule"
      :title="$t('W: Annullér planlægning')"
      @select="onCancelScheduleClick">
      <template #icon>
        <IconLucideCalendarX class="h-4 w-4" />
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

/**
 * What a scheduled delivery can do next. Same two release actions as an approved one, plus
 * calling the schedule off — which returns it to approved rather than un-approving it.
 */
export default {
  name: 'OrderScheduledDeliveryMenu',

  emits: ['close'],

  props: {
    onSendNow: { type: Function as PropType<() => void>, required: true },
    onMarkSentManually: {
      type: Function as PropType<() => void>,
      required: true,
    },
    onCancelSchedule: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },

  methods: {
    onSendNowClick(): void {
      this.onSendNow()
      this.$emit('close')
    },

    onMarkSentManuallyClick(): void {
      this.onMarkSentManually()
      this.$emit('close')
    },

    onCancelScheduleClick(): void {
      this.onCancelSchedule()
      this.$emit('close')
    },
  },
}
</script>
